import React from "react";

export function ViewResultsTab({ data, legendDefinitions }) {
  
  const calculateFinalScore = () => {
    if (!data.scores) return "0.00";
    return data.scores.reduce((sum, s) => sum + parseFloat(s.computedScore || 0), 0).toFixed(2);
  };

  const finalScore = calculateFinalScore();

  return (
    <div className="space-y-6">
      <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
        <table className="min-w-full border-collapse">
          <thead className="bg-sky-600 text-white">
            <tr>
              <th className="px-6 py-4 text-left text-xs font-bold uppercase tracking-widest">Objectives & Comments</th>
              <th className="px-4 py-4 text-center text-xs font-bold uppercase tracking-widest w-28">Weight</th>
              <th className="px-4 py-4 text-center text-xs font-bold uppercase tracking-widest w-32">Rating</th>
              <th className="px-6 py-4 text-right text-xs font-bold uppercase tracking-widest w-44">Computed Score</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {data.performanceCategories?.map((cat) => (
              <React.Fragment key={cat.id}>
                {/* Category Header Row - Matched to Summary "Blueprint" style */}
                <tr className="bg-gray-200">
                  <td colSpan="4" className="px-6 py-2 text-sm font-bold text-gray-500 uppercase tracking-wider">
                    CATEGORY: {cat.description}
                  </td>
                </tr>
                
                {cat.objectives?.map((obj) => {
                  const scoreObj = data.scores?.find(s => s.performanceObjectiveId === obj.id);
                  return (
                    <tr key={obj.id} className="hover:bg-gray-100 transition-colors">
                      <td className="px-6 py-4 align-top">
                        {/* Objective Code - text-gray-600 */}
                        <div className="font-bold text-gray-600 text-sm tracking-tight">Code : {obj.code}</div>
                        {/* Comments - text-sm and text-gray-400 to match summary descriptions */}
                        <div className="text-sm text-gray-400 mt-1 italic leading-relaxed">
                            {scoreObj?.comment || "No comment provided."}
                        </div>
                      </td>
                      
                      {/* Weight - text-sm text-gray-400 */}
                      <td className="px-4 py-4 text-center align-top text-sm text-gray-400 font-bold">
                        {obj.percentage}%
                      </td>
                      
                      {/* Rating Badge - bg-sky-100 text-sky-600 */}
                      <td className="px-4 py-4 text-center align-top">
                        <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-black bg-sky-100 text-sky-600 border border-sky-200">
                          {scoreObj?.score || 0}
                        </span>
                      </td>
                      
                      {/* Computed Score - text-gray-600 font-mono */}
                      <td className="px-6 py-4 text-right align-top font-mono font-bold text-sm text-gray-600">
                        {scoreObj?.computedScore?.toFixed(2) || "0.00"}
                      </td>
                    </tr>
                  );
                })}
              </React.Fragment>
            ))}
          </tbody>
          
          {/* Footer - Slightly brighter Sky theme */}
          <tfoot className="bg-sky-50 border-t-2 border-sky-100">
            <tr>
              <td colSpan="3" className="px-6 py-6 text-right text-xs font-bold text-sky-500 uppercase tracking-widest">
                Overall Final Score
              </td>
              <td className="px-6 py-6 text-right font-black text-3xl text-sky-600">
                {finalScore}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}